import { render, staticRenderFns } from "./BrandManage.vue?vue&type=template&id=f4e50336&scoped=true&"
import script from "./BrandManage.vue?vue&type=script&lang=js&"
export * from "./BrandManage.vue?vue&type=script&lang=js&"
import style0 from "./BrandManage.vue?vue&type=style&index=0&id=f4e50336&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e50336",
  null
  
)

export default component.exports